import {axiosGet} from "../../../Helpers/AxiosHelper";

const state = {
    personListRe: []
};

const getters = {
    getPersonRe: state => state.personListRe
};

const actions = {
    getPersonRe({commit}) {
        axiosGet(`crm/persons?re`).then(({data}) => {
            commit('PERSON_INFO', data)
        }).catch((error) => console.log(error));
    },
};

const mutations = {
    PERSON_INFO(state, data) {
        state.personListRe = data;
    }
};


export default {
    state,
    getters,
    actions,
    mutations
}
